<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_143936' | translate }} {{ 'ml_143925' | translate }}</h2>

  <div mat-dialog-content class="m-0 mt-3">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row mt-3">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ml_143915' | translate}}</mat-label>
            <mat-select formControlName="compliance" [disabled]="updating$ | async">
              @for (item of complianceSelectItems; track $index) {
              <mat-option [value]="item.value">
                {{item.label | translate}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if(isOccurrenceTargetEditable){
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151067' | translate}}</mat-label>
            <input matInput type="number" placeholder="" formControlName="occurrence" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_151068' | translate}}</mat-label>
            <input matInput type="number" placeholder="" formControlName="targetOccurrence" />
          </mat-form-field>
        </div>
      </div>
      }
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="updating$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
